import useSWR from 'swr';

import { localSwrConfig, fetchData } from '@/helpers/swr';
import { useListEntrySwrConfig } from '@/helpers/_hooks';

const rolesKey = () => `/role`;

const useRoles = (shouldRevalidate = true) => {
  const swr = useSWR(rolesKey(), fetchData, shouldRevalidate ? undefined : localSwrConfig);

  return swr;
};

/**
 * A role by uid, or undefined when it isn't one of the current company's.
 *
 * Callers must handle the miss. /role is scoped to the company being viewed, so a
 * zebeler looking at another company holds a role_uid from their own company that is
 * not in this list — the lookup legitimately comes back empty for them.
 */
const useRoleObject = (uid) => {
  const roles = useSWR(rolesKey(), fetchData, useListEntrySwrConfig(uid));
  return roles.data.content[uid];
};

export { useRoles, useRoleObject };
